'use client';

import { useState, useEffect } from 'react';
import CustomTable from '@/modules/Portaria/components/CustomTable';
import ModalRetorno from '@/modules/Portaria/components/ModalRetorno';
import { useNavigate } from 'react-router-dom';
import { useRemove } from '../service';
import { Spinner, Center } from '@chakra-ui/react';
import ModalConfirmacao from '@/components/ModalConfirmacao';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaContratacao({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isDeleting, setIsDeleting] = useState(false);
  const [mensagemErro, setMensagemErro] = useState<string | null>(null);
  const [mensagemSucesso, setMensagemSucesso] = useState<string | null>(null);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedToDelete, setSelectedToDelete] = useState<any[]>([]);

  const navigate = useNavigate();
  const { mutate: remove } = useRemove();

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  const handleDeleteRecords = (selectedData: any[]) => {
    if (selectedData.length === 0) {
      setMensagemErro('Selecione pelo menos um registro para remover.');
      return;
    }
    setSelectedToDelete(selectedData);
    setIsConfirmOpen(true);
  };


  const confirmDelete = () => {
    setIsDeleting(true);
    setIsConfirmOpen(false);
    setMensagemErro(null);
    setMensagemSucesso(null);

    const selectedIds = selectedToDelete.map(item => item.id);
    let completed = 0;
    let hasError = false;

    selectedIds.forEach(id => {
      remove(id, {
        onSuccess: () => {
          setTableData(prev => prev.filter(item => item.id !== id));
          completed++;
          if (completed === selectedIds.length) {
            setIsDeleting(false);
            if (!hasError) {
              setMensagemSucesso('Registros removidos com sucesso!');
            }
          }
        },
        onError: () => {
          hasError = true;
          setMensagemErro(`Erro ao remover o registro de ID ${id}.`);
          setIsDeleting(false);
        },
      });
    });

    onDelete(selectedToDelete);
    setSelectedToDelete([]);
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      {isDeleting ? (
        <Center h="200px">
          <Spinner size="xl" />
        </Center>
      ) : (
        <CustomTable
          headers={headers}
          data={tableData}
          searchValue={valoPesquisa}
          onDelete={handleDeleteRecords}
          onAdd={() => navigate('novo')}
          onEdit={(id: number) => navigate(`${id}`)}
          onDataChange={handleDataChange}
          showActions={true}
          isReadSwitch={true}
        />
      )}

      {(mensagemErro || mensagemSucesso) && (
        <ModalRetorno
          isOpen={true}
          onClose={() => {
            setMensagemErro(null);
            setMensagemSucesso(null);
          }}
          mensagem={mensagemErro || mensagemSucesso || ''}
          tipo={mensagemErro ? 'erro' : 'sucesso'}
        />
      )}

      <ModalConfirmacao
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={confirmDelete}
        isLoading={isDeleting}
        quantidade={selectedToDelete.length}
      />
    </>
  );
}
